import { useSelector } from "react-redux";
import { Roles, ShowExhibitorChatMode } from "@evennt-tech/api-v2-core";
import { selectUser } from "store/auth/selectors";
import { useEmbeddedChatStore } from "store/embedded-chat/embedded-chat.store";
import { isPublicRoute } from "tools/routing";
import useCurrentShow from "./useCurrentShow";

const useEmbeddedChatActive = (): boolean => {
  // On public/unauthenticated routes (e.g. /show-info/:showId) embedded chat
  // is never active. Disable useCurrentShow so it doesn't fire the
  // auth-only show fetch that would bounce anonymous visitors to /login.
  const isPublic = isPublicRoute();
  const [show] = useCurrentShow({ enabled: !isPublic });
  const { role } = useSelector(selectUser);
  const embeddedChat = useEmbeddedChatStore((state) => state.embeddedChat);

  if (isPublic) return false;

  return (
    role === Roles.EXHIBITOR &&
    !!embeddedChat &&
    show?.exhibitorChatMode === ShowExhibitorChatMode.Embedded
  );
};

export default useEmbeddedChatActive;
